import { DialogProps, Dialog as MuiDialog } from "@mui/material";
import { limitMaxResolutionStyles } from "../Common.style";

export const Dialog = (props: DialogProps) => {
  const additionalStyles = props.fullScreen ? limitMaxResolutionStyles : {};
  return (
    <MuiDialog
      style={{ ...props.style, ...additionalStyles }}
      {...props}
      closeAfterTransition={false}
    ></MuiDialog>
  );
};
